import { create } from "zustand";

import { TGetUserRes } from "@type/api/user/types";
import { DEFAULT_VALUE } from "constants/index";

export type TUser = Omit<TGetUserRes, "type"> & {
  isSuperAdmin: boolean;
  language: string;
};

type TAuthStore = {
  isLoading: boolean;
  isLogin: boolean;
  user: TUser;
  onSetLoading: (isLoading: boolean) => void;
  onSetIsLogin: (isLogin: boolean) => void;
  onSetUser: (user: TUser) => void;
};

export const INIT_USER: TUser = {
  idUnique: "",
  email: "",
  fullName: "",
  preferredName: "",
  profilePicture: "",
  isSuperAdmin: false,
  language: DEFAULT_VALUE.LANGUAGE,
};

export const useAuthStore = create<TAuthStore>((set) => ({
  isLoading: false,
  isLogin: false,
  user: INIT_USER,
  onSetLoading: (isLoading) => {
    set({ isLoading });
  },
  onSetIsLogin: (isLogin) => {
    set({ isLogin });
  },
  onSetUser: (user) => {
    set((state) => ({
      ...state.user,
      user: {
        ...state.user,
        ...user,
      },
    }));
  },
}));
